import styled from 'styled-components';
export const Container = styled.button `
  border: ${(props) => props.isSelected ? '1px solid #1F35B5' : '1px dashed #A7A7A7'};
  background: ${(props) => props.isSelected ? '#E8EAF8' : 'none'};
  border-radius: 5px;
  padding: 15px 20px;
  cursor: pointer;
  width: 100%;
`;
//# sourceMappingURL=styles.js.map